import React from "react";
import { Field, change } from "redux-form";
import Step from "../Step";

import styles from "../styles.module.css";
import WithUserForm from "../../Register/WithUserForm";
import withHooks from "react-with-hooks";
import CTAButton from "../../utils/Button/CTAButton";
import { dataFieldsOptions } from "@schmodel/core";

const brandTypesFashionAndAccessories = dataFieldsOptions.brandTypes.filter(
  b => b.group === 'Fashion apparel' || b.group === 'Fashion accessories'
);
const brandTypesBeauty = dataFieldsOptions.brandTypes.filter(
  b => b.group === 'Beauty products'
);

const onCameraSkills = dataFieldsOptions.skills.filter(s => s.onCamera);
const offCameraSkills = dataFieldsOptions.skills.filter(s => !s.onCamera);


const Tag = ({ item, isSelected, onPress, style = {}}) => (
  <button
    type="button"
    className={`${styles.tag} ${style} ${isSelected ? styles.skill_button_selected : ''}`}
    onClick={() => onPress(item.value)}
  >
    {item.label}
  </button>
);

const SelectedSkills = withHooks((props) => {
  const { activeTab, checkedItems, handleToggleItem } = props;

  if (activeTab === 'talent') {
    return (
      <div className={styles.skills_categories}>
        <p className={styles.section_label}>On-Camera</p>
        <div className={styles.skill_buttons_grid}>
          {onCameraSkills.map(item => (
            <Tag
              key={item.value}
              item={item}
              isSelected={checkedItems.includes(item.value)}
              onPress={handleToggleItem}
            />
          ))}
        </div>
        <p
            className={styles.section_label}
           style={{ marginTop: '3vh' }}
        >Off-Camera</p>
        <div className={styles.skill_buttons_grid}>
          {offCameraSkills.map(item => (
            <Tag
              key={item.value}
              item={item}
              isSelected={checkedItems.includes(item.value)}
              onPress={handleToggleItem}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.skills_categories}>
      <p className={styles.section_label}>Fashion</p>
      <div className={styles.skill_buttons_grid}>
        {brandTypesFashionAndAccessories.map(item => (
          <Tag
            key={item.value}
            item={item}
            isSelected={checkedItems.includes(item.value)}
            onPress={handleToggleItem}
            style={styles.fashion_types}
          />
        ))}
      </div>
      <p className={styles.section_label} style={{ marginTop: '3vh' }}>Beauty products</p>
      <div className={styles.skill_buttons_grid}>
        {brandTypesBeauty.map(item => (
          <Tag
            key={item.value}
            item={item}
            isSelected={checkedItems.includes(item.value)}
            onPress={handleToggleItem}
            style={styles.beauty_types}
          />
        ))}
      </div>
    </div>
  );
});

export default class StepSkills extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'talent',
      checkedItems: [],
      isError: false,
    };
  }

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab, checkedItems: [] });
  };

  handleToggleItem = (value) => {
    const { checkedItems } = this.state;
    if (checkedItems.includes(value)) {
      this.setState({ checkedItems: checkedItems.filter(v => v !== value) });
    } else {
      this.setState({ checkedItems: [...checkedItems, value] });
    }
  };

  async onSubmit(values, _, props) {
    const { activeTab, checkedItems } = this.state;
    if (checkedItems.length === 0) {
      this.setState({ isError: true });
      return;
    }
    if (activeTab === 'talent') {
      props.dispatch(change('signup', 'skills', checkedItems));
      const formattedValues = WithUserForm.formatUserSkillsInput({ ...values, skills: checkedItems });
      await props.updateUserSkills({ variables: { input: formattedValues } });
    } else {
      props.dispatch(change('signup', 'brandTypes', checkedItems));
      const formattedValues = WithUserForm.formatUserBrandTypesInput({ ...values, brandTypes: checkedItems });
      await props.updateUserBrandTypes({ variables: { input: formattedValues } });
    }
    return props.machine.service.send({ type: "NEXT" });
  }

  render() {
    const { activeTab, checkedItems } = this.state;
    return (
      <WithUserForm
        onSubmit={(values, _, props) => this.onSubmit(values, _, props)}
      >
        {({form: { handleSubmit }}) => {
          const footer = (
              <div
                  style={{
                    width: '90vw',
                    maxWidth: '400px',
                    minHeight: activeTab === 'talent' ? '70px' : '150px',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    paddingBottom: '10px'
                  }}
              >
                <div style={{ width: '100%', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  {/* Center cta button in available space between text and footer*/}
                  <CTAButton
                      onClick={handleSubmit}
                      disabled={checkedItems.length === 0}
                      text={'Next'}
                  />
                </div>
                <p
                    className={` ${styles.default_text_size}`}
                    style={{
                      color: '#B08D57',
                      lineHeight: 0.9
                    }}
                >
                  Having trouble? <a href="https://wa.me/447588663357" style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Contact us</a>.
                </p>
              </div>
          );
          return (
            <Step footer={footer} scrollable>
              <p
                className="text-white text-md"
                style={{
                  fontWeight: 700,
                  fontSize: 'clamp(1px, 4vw, 18px)' ,
                  marginTop: activeTab === 'talent' ? 0 : '50px'
              }}
              >What do you do?</p>
              <div className={styles.tab_bar}>
                <button
                  type="button"
                  className={`${styles.tab} ${activeTab === 'talent' ? styles.tab_active : ''}`}
                  onClick={() => this.setActiveTab('talent')}
                >
                  I am Creative Talent
                </button>
                <button
                  type="button"
                  className={`${styles.tab} ${activeTab === 'brand' ? styles.tab_active : ''}`}
                  onClick={() => this.setActiveTab('brand')}
                >
                  I am a Brand
                </button>
              </div>
              <form onSubmit={handleSubmit} className={styles.form_step_skills}>
                <Field
                  name="skills"
                  component={SelectedSkills}
                  activeTab={activeTab}
                  checkedItems={checkedItems}
                  handleToggleItem={this.handleToggleItem}
                />
              </form>
            </Step>
          );
        }}
      </WithUserForm>
    );
  }
}
